import {axios} from "@/api/config";
// 查询危险源管理列表
export function listDangersrc(params) {
  return axios.get(`/dangersrc/list`, params, true);
}

// 查询危险源管理详细
export function getDangersrc(dangersrcId) {
  return axios.get(`/dangersrc/${dangersrcId}`, dangersrcId, true)
}

// 新增危险源管理
export function addDangersrc(params) {
  return axios.post('/dangersrc/addDangersrc', params, false);
}

// 修改危险源管理
export function updateDangersrc(params) {
  return axios.post('/dangersrc/editDangersrc', params, false);
}


// 删除危险源管理
export function delDangersrc(dangersrcId) {
  return axios.delete(`/dangersrc/${dangersrcId}`, true)
}

